/* Zero 1 — home page interactions (Sep 2026).
   Ported from the concept homepage script. Drawer/toast/newsletter removed —
   the theme handles those. Every lookup is null-safe. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Reveal on scroll ---- */
    var revealEls = document.querySelectorAll('.rv');
    if (revealEls.length) {
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        revealEls.forEach(function (el) { io.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('in'); });
      }
    }

    /* ---- Gauge geometry (bottom-open, 240° sweep) ---- */
    var CX = 100, CY = 100, R = 74, A0 = 150, SWEEP = 240; // degrees; start lower-left, clockwise
    function pt(ang) {
      var r = ang * Math.PI / 180;
      return [CX + R * Math.cos(r), CY + R * Math.sin(r)];
    }
    var p0 = pt(A0), p1 = pt(A0 + SWEEP);
    var arcLen = 2 * Math.PI * R * (SWEEP / 360);
    var track = document.getElementById('gTrack'),
        fill = document.getElementById('gFill'),
        needle = document.getElementById('gNeedle'),
        hub = document.getElementById('gHub'),
        ticks = document.getElementById('gTicks'),
        label = document.getElementById('gLabel');

    if (track && fill) {
      var d = 'M' + p0[0].toFixed(1) + ',' + p0[1].toFixed(1) + ' A' + R + ',' + R + ' 0 1 1 ' + p1[0].toFixed(1) + ',' + p1[1].toFixed(1);
      track.setAttribute('d', d);
      fill.setAttribute('d', d);
      fill.setAttribute('stroke-dasharray', arcLen);
      fill.setAttribute('stroke-dashoffset', arcLen);
      if (hub) { hub.setAttribute('cx', CX); hub.setAttribute('cy', CY); }
      if (label) { label.setAttribute('x', CX); label.setAttribute('y', CY + 34); }
      if (ticks) {
        var tk = '';
        for (var i = 0; i <= 4; i++) {
          var a = A0 + SWEEP * (i / 4),
              o = pt(a),
              inr = [CX + (R - 11) * Math.cos(a * Math.PI / 180), CY + (R - 11) * Math.sin(a * Math.PI / 180)];
          tk += '<line x1="' + o[0].toFixed(1) + '" y1="' + o[1].toFixed(1) + '" x2="' + inr[0].toFixed(1) + '" y2="' + inr[1].toFixed(1) + '"/>';
        }
        ticks.innerHTML = tk;
      }
    }

    function setGauge(p) { // p 0..1
      if (!track || !fill || !needle) return;
      fill.setAttribute('stroke-dashoffset', arcLen * (1 - p));
      var a = A0 + SWEEP * p,
          np = [CX + (R - 14) * Math.cos(a * Math.PI / 180), CY + (R - 14) * Math.sin(a * Math.PI / 180)];
      needle.setAttribute('x1', CX);
      needle.setAttribute('y1', CY);
      needle.setAttribute('x2', np[0].toFixed(1));
      needle.setAttribute('y2', np[1].toFixed(1));
    }
    setGauge(reduce ? 1 : 0);

    /* ---- Scroll-driven: parallax band + process rail/steps/gauge ---- */
    var cinePhoto = document.querySelector('.cine-photo'),
        cine = document.getElementById('z1-cine'),
        proc = document.getElementById('z1-process'),
        railFill = document.getElementById('prailFill'),
        steps = [].slice.call(document.querySelectorAll('.pstep'));

    function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    function onScroll() {
      var vh = window.innerHeight;
      if (cine && cinePhoto && !reduce) {
        var cr = cine.getBoundingClientRect();
        var prog = clamp((vh - cr.top) / (vh + cr.height)); // 0..1 as it passes
        cinePhoto.style.transform = 'translateY(' + ((prog - 0.5) * 14).toFixed(2) + '%)';
      }
      if (proc) {
        var pr = proc.getBoundingClientRect();
        // progress across the section: 0 when top at 78% vh, 1 when bottom near 40% vh
        var start = vh * 0.78, end = vh * 0.32;
        var raw = (start - pr.top) / ((start - end) + pr.height * 0.0 + (pr.height * 0.30));
        var p = clamp(raw);
        if (railFill) railFill.style.height = (p * 100).toFixed(1) + '%';
        if (steps.length) {
          var active = Math.min(steps.length, Math.ceil(p * steps.length));
          steps.forEach(function (s, i) { s.classList.toggle('on', i < active); });
        }
        setGauge(reduce ? 1 : clamp(p * 1.05));
      }
    }

    var ticking = false;
    function req() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { onScroll(); ticking = false; });
      }
    }
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    onScroll();

    if (reduce) {
      steps.forEach(function (s) { s.classList.add('on'); });
      if (railFill) railFill.style.height = '100%';
    }
  });
})();
